//Generate QR Codes for inspections, allowing admin to specify number of codes needed and download as PDF

import { useState } from "react";
import Footer from "../common/Footer";
import Header from "../common/Header";
import Sidebar from "../common/Sidebar";
import SidebarIcons from "../common/SidebarIcons";
import { useSelector } from "react-redux";
import http from "../../api/server";
import { GENERATE_QR } from "../../api/apiPath";
import PdfPreviewIframe from "../common/PdfPreviewIframe";
import useGetClientId from "../../hooks/useGetClientId";
const isMobile = /Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
import Toaster from "../common/Toaster";

export default function QRCodes() {
  const [hideSidebar, setHideSidebar] = useState(false);
  const { userObj } = useSelector((state) => state.user);
  const [inputValue, setInputValue] = useState("");
  const [loading, setLoading] = useState(false);
  const [qrResult, setQrResult] = useState(null);

  const [error, setError] = useState("");
  const [pdfUrl, setPdfUrl] = useState(null);
  const [showPdfModal, setShowPdfModal] = useState(false);
  const clientObj = useGetClientId();

  const [toastData, setToastData] = useState({
    toastShow: false,
    toastType: "",
    toastString: "",
  });
  const closeButton = () => {
    setToastData({
      toastShow: false,
      toastData: "",
      toastType: "",
    });
  };

  const handleChange = (e) => {
    const value = e.target.value;
    if (value === "" || (Number(value) >= 0 && Number(value) <= 60)) {
      setInputValue(value);
      setError("");
    }
  };

  //Generate QR code PDF based on number of codes specified, and trigger download or show in modal based on device type
  const handleGenerate = async () => {
    if (!inputValue || inputValue == "0") {
      setError("Please enter valid number of QR codes");
      return;
    }
    console.log(setQrResult);

    try {
      setLoading(true);

      const payload = {
        ClientId: clientObj?.clientId,
        LoggedinUserId: userObj?.userId,
        NumberOfQRCodes: Number(inputValue),
      };

      const response = await http.post(GENERATE_QR, payload, {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/pdf",
        },
        responseType: "blob",
      });

      const blob = new Blob([response.data], { type: "application/pdf" });
      const pdfUrl = URL.createObjectURL(blob);

      setPdfUrl(pdfUrl);
      setShowPdfModal(true);
      if (isMobile) {
        const link = document.createElement("a");
        link.href = pdfUrl;
        link.download = "QRcode.pdf";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } else {
        setShowPdfModal(true);
      }
    } catch (err) {
      console.error("Error generating QR:", err);
      console.log("Something went wrong while generating QR Codes");
      setToastData({
        toastShow: true,
        toastType: "failure",
        toastString: err.message || "Unknown error occurred",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Header hideSidebar={hideSidebar} setHideSidebar={setHideSidebar} />
      {userObj && (
        <div className="dashboard_body_main vh-100">
          <Toaster
            show={toastData.toastShow}
            toastType={toastData.toastType}
            title={toastData.toastString}
            theme={"dark"}
            position="top-center"
            closeButton={closeButton}
          />
          {hideSidebar ? (
            <Sidebar
              setHideSidebar={setHideSidebar}
              hideSidebar={hideSidebar}
            />
          ) : (
            <SidebarIcons 
             setHideSidebar={setHideSidebar}
              hideSidebar={hideSidebar}
              />
          )}

          <div className="d-flex dashboard_body flex-column py-1  w-100 mt-3 personalFont ">
            <div>
              <h3 className="fw-semibold">Generate QR Code</h3>
              <h4 className="text fs-5">Generate Inspection QR codes for your locations</h4>
            </div>
            <div className="d-flex justify-content-center align-items-center mt-5" >
              <div className="card shadow w-50 " style={{border:"none"}}>
              <div className="card-body justify-content-center align-items-center "style={{margin:"40px"}}>
                <h5 className="card-title text-start fw-semibold ">Number of QR Codes </h5>

            <input
              type="number"
              min="1"
              max="60"
              value={inputValue}
              onChange={handleChange}
              placeholder="Enter a number between 1 and 60"
              className="form-controlinputbox w-100 mt-2"
            />
            {error && <span className="formError mt-2">{error}</span>}
            <button
              type="button"
              className="btn btn-primary shadow mt-3 w-100"
              onClick={handleGenerate}
              disabled={loading}
            >
              {loading ? "Generating..." : "Generate QR Code(s)"}
            </button>

            {qrResult && (
              <div className="mt-4">
                <h5>QR Codes Generated</h5>
                <pre>{JSON.stringify(qrResult, null, 2)}</pre>
              </div>
            )}
          </div>


              </div>
            </div>
            </div>
          <Footer />
        </div>
      )}
      {showPdfModal && pdfUrl && (
        <PdfPreviewIframe
          pdfUrl={pdfUrl}
          onClose={() => {
            setShowPdfModal(false);
            setPdfUrl(null);
          }}
        />
      )}
    </>
  );
}
